module.exports = __webpack_public_path__ + "img/common_unsubscribe.95714c0b.svg";